export default __webpack_public_path__ + "static/media/trident.4d99ef8c.png";